import React from "react";
import bannerImage from "../assets/Advertise-image-webp.webp";
import videoAds from "../assets/Ads-Video.mp4";
import blogsSiteAds from "../assets/blogsVid.mp4";

export default function SidebarRight() {
  return (
    <aside className="w-full md:w-64 rounded-2xl h-auto md:h-[calc(100vh-4rem)] bg-black border-2 border-red-500 text-white p-2 md:p-4 shrink-0 overflow-hidden">
      <h2 className="font-bold mb-4">Sponsored by:</h2>

      {/* Two image banners with links */}
      <div className="w-full h-auto md:h-[calc(100%-3rem)] flex flex-col gap-4">
        {/* First banner with blogs.punote.com link */}
        <a
          href="https://blogs.punote.com/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="punote blogs website"
          className="w-full h-48 md:h-1/2 rounded overflow-hidden border border-gray-600 hover:border-green-400 transition-all duration-200 hover:shadow-lg hover:shadow-green-500/20"
        >
          <video
            autoPlay
            muted
            loop
            playsInline
            className="w-full h-full object-contain hover:scale-105 transition-transform duration-200"
          >
            <source src={blogsSiteAds} type="video/mp4" />
            {/* Fallback for browsers that don't support video */}
            <img
              src={bannerImage}
              alt="Punote Main Website"
              className="w-full h-full object-contain"
            />
          </video>
        </a>
        
        {/* Second banner with punote.com link */}
        <a
          href="https://punote.com/contact"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="contact us page of punote"
          className="w-full h-48 md:h-1/2 rounded overflow-hidden border border-gray-600 hover:border-green-400 transition-all duration-200 hover:shadow-lg hover:shadow-green-500/20"
        >
          <video
            autoPlay
            muted
            loop
            playsInline
            className="w-full h-full object-contain hover:scale-105 transition-transform duration-200"
          >
            <source src={videoAds} type="video/mp4" />
            {/* Fallback for browsers that don't support video */}
            <img
              src={bannerImage}
              alt="Punote Main Website"
              className="w-full h-full object-contain"
            />
          </video>
        </a>
      </div>
    </aside>
  );
}